import React from "react";
import styles from "./BusinessConfig.module.scss";
import { Divider } from "@material-ui/core";
import { InputLabel, TextField } from "@material-ui/core";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import Select from "../../formUI/Select";
import { makeStyles } from "@material-ui/core";
import { useDispatch } from "react-redux";
import axios from "axios";
import { openToastAndSetContent } from "../../../redux/actions/toast/toastActions";
import {
	openLoader,
	closeLoader,
} from "../../../redux/actions/loader/loaderActions";
import { closeModal } from "../../../redux/actions/modal/modalActions";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";

const useStyles = makeStyles({
	root: {
		"& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
			border: "none",
		},
		"& .MuiOutlinedInput-input.MuiInputBase-input.MuiInputBase-input.MuiOutlinedInput-input":
			{
				textAlign: "center",
				padding: "8.1px 14px",
			},
	},
	select: {
		"& .MuiOutlinedInput-root": {
			color: "#414141",
			fontFamily: "Avenir",
			fontStyle: "normal",
			fontWeight: "normal",
			fontSize: "14px",
			lineHeight: "16px",
		},
		"&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
			outline: "none",
		},
		"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
			backgroundColor: "#ffffff",
		},
		"& .MuiInputLabel-root.Mui-focused": {
			color: "#E0E0E0",
		},
		"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
			border: "1px solid #E0E0E0",
		},
	},
});

function BusinessConfig({
	id,
	setBearer,
	config,
}: {
	id: number | undefined;
	setBearer: React.Dispatch<React.SetStateAction<boolean>>;
	config: any;
}) {
	const classes = useStyles();

	const dispatch = useDispatch();

	const validate = Yup.object({
		allowAPI: Yup.boolean().required("Required"),
		enableRollingReserve: Yup.boolean().required("Required"),
		rollingReserveSetting: Yup.number().required("Required"),
		rollingReservePeriod: Yup.number().required("Required"),
		allowNoauth: Yup.boolean().required("Required"),
		settlementOption: Yup.string().required("Required"),
		allowPaymentLink: Yup.string().required("Required"),
		otp: Yup.string().required("Required"),
	});

	const settlementOption = [
		{
			name: "ACCOUNT",
		},
		{
			name: "BALANCE",
		},
	];

	const contentBoolean = [
		{
			name: "false",
		},
		{
			name: "true",
		},
	];

	const INITIAL_VALUES = {
		allowAPI: config.allowapi === false ? "false" : "true" || "N/A",
		enableRollingReserve:
			config.enablerollingreserve === false ? "false" : "true" || "N/A",

		rollingReserveSetting: config.rollingreservesetting,
		rollingReservePeriod: config.rollingreserveperiod,
		allowNoauth: config.allownoauth === false ? "false" : "true" || "N/A",
		settlementOption: config.settlementoption,
		allowPaymentLink:
			config.allowpaymentlink === false ? "false" : "true" || "N/A",
		otp: "",
	};

	return (
		<div className={styles.generalFourReuse}>
			<h3 className={styles.generalh3}>Config Business</h3>
			<Divider />

			<div className={styles.selectinput}>
				<Formik
					initialValues={INITIAL_VALUES}
					validationSchema={validate}
					onSubmit={(values) => {
						dispatch(openLoader());

						axios
							.post(`v1/business/${id}/config`, {
								allowAPI: Boolean(values.allowAPI),
								enableRollingReserve: Boolean(values.enableRollingReserve),
								rollingReserveSetting: values.rollingReserveSetting,
								rollingReservePeriod: values.rollingReservePeriod,
								allowNoauth: Boolean(values.allowNoauth),
								settlementOption: values.settlementOption,
								allowPaymentLink: Boolean(values.allowPaymentLink),
								otp: values.otp,
							})
							.then((res: any) => {
								setBearer(true);
								dispatch(closeLoader());
								dispatch(
									openToastAndSetContent({
										toastContent: res?.data?.message,
										toastType: "success",
									})
								);
								dispatch(closeModal());
							})
							.catch((err) => {
								dispatch(closeLoader());
								dispatch(
									openToastAndSetContent({
										toastContent:
											err?.response?.data?.message ||
											err?.data?.message ||
											err?.message ||
											err,
										toastType: "error",
									})
								);
							});
					}}
				>
					{(props) => (
						<Form>
							<InputLabel>
								<span className={styles.span}>ALLOW API</span>
							</InputLabel>
							<Field
								as={Select}
								helperText={
									<ErrorMessage name="allowAPI">
										{(msg) => <span style={{ color: "red" }}>{msg}</span>}
									</ErrorMessage>
								}
								name="allowAPI"
								size="small"
								options={contentBoolean}
								className={classes.select}
								// fullWidth
								style={{
									marginTop: "8px",
									marginBottom: "22px",
								}}
							/>

							<InputLabel>
								<span className={styles.span}>ROLLING RESERVE</span>
							</InputLabel>
							<Field
								as={Select}
								helperText={
									<ErrorMessage name="enableRollingReserve">
										{(msg) => <span style={{ color: "red" }}>{msg}</span>}
									</ErrorMessage>
								}
								name="enableRollingReserve"
								size="small"
								options={contentBoolean}
								className={classes.select}
								// fullWidth
								style={{
									marginTop: "8px",
									marginBottom: "22px",
								}}
							/>

							<InputLabel>
								<span className={styles.span}>RESERVE SETTING</span>
							</InputLabel>
							<Field
								as={TextField}
								helperText={
									<ErrorMessage name="rollingReserveSetting">
										{(msg) => <span style={{ color: "red" }}>{msg}</span>}
									</ErrorMessage>
								}
								name="rollingReserveSetting"
								variant="outlined"
								margin="normal"
								type="number"
								size="small"
								fullWidth
								className={classes.select}
								style={{
									marginTop: "8px",
									marginBottom: "22px",
								}}
							/>
							<InputLabel>
								<span className={styles.span}>ROLLING RESERVE PERIOD</span>
							</InputLabel>
							<Field
								as={TextField}
								helperText={
									<ErrorMessage name="rollingReservePeriod">
										{(msg) => <span style={{ color: "red" }}>{msg}</span>}
									</ErrorMessage>
								}
								name="rollingReservePeriod"
								variant="outlined"
								margin="normal"
								type="number"
								size="small"
								fullWidth
								className={classes.select}
								style={{
									marginTop: "8px",
									marginBottom: "22px",
								}}
							/>

							<InputLabel>
								<span className={styles.span}>ALLOW NO AUTH</span>
							</InputLabel>
							<Field
								as={Select}
								helperText={
									<ErrorMessage name="allowNoauth">
										{(msg) => <span style={{ color: "red" }}>{msg}</span>}
									</ErrorMessage>
								}
								name="allowNoauth"
								size="small"
								options={contentBoolean}
								className={classes.select}
								// fullWidth
								style={{
									marginTop: "8px",
									marginBottom: "22px",
								}}
							/>

							<InputLabel>
								<span className={styles.span}>SETTLEMENT OPTION</span>
							</InputLabel>
							<Field
								as={Select}
								helperText={
									<ErrorMessage name="settlementOption">
										{(msg) => <span style={{ color: "red" }}>{msg}</span>}
									</ErrorMessage>
								}
								name="settlementOption"
								size="small"
								options={settlementOption}
								className={classes.select}
								// fullWidth
								style={{
									marginTop: "8px",
									marginBottom: "22px",
								}}
							/>

							<InputLabel>
								<span className={styles.span}>ALLOW PAYMENT LINK</span>
							</InputLabel>
							<Field
								as={Select}
								helperText={
									<ErrorMessage name="allowPaymentLink">
										{(msg) => <span style={{ color: "red" }}>{msg}</span>}
									</ErrorMessage>
								}
								name="allowPaymentLink"
								size="small"
								options={contentBoolean}
								className={classes.select}
								// fullWidth
								style={{
									marginTop: "8px",
									marginBottom: "22px",
								}}
							/>

							<InputLabel>
								<span className={styles.span}>OTP</span>
							</InputLabel>
							<Field
								as={TextField}
								helperText={
									<ErrorMessage name="otp">
										{(msg) => <span style={{ color: "red" }}>{msg}</span>}
									</ErrorMessage>
								}
								name="otp"
								InputLabelProps={{
									style: { fontSize: "0.8em" },
								}}
								label="Get OTP from Google Authenticator App"
								variant="outlined"
								margin="normal"
								type="text"
								size="small"
								fullWidth
								className={classes.select}
								style={{
									marginTop: "8px",
								}}
							/>
							<InputLabel>
								<div style={{ display: "flex", alignItems: "center" }}>
									<InfoRoundedIcon />
									<p className={styles.info}>
										If you have not set up your 2FA, kindly{" "}
										<a
											style={{ color: "blue" }}
											href={`/account`}
											target="_blank"
										>
											click here
										</a>
									</p>
								</div>
							</InputLabel>

							<button
								style={{
									backgroundColor: "#27AE60",
									fontFamily: "Avenir",
									fontStyle: "normal",
									fontWeight: "bold",
									fontSize: "16px",
									lineHeight: "19px",
									textAlign: "center",
									border: "none",
									outline: "none",
									width: "100%",
									color: "#FFFFFF",
									padding: "13.39px 0",
									borderRadius: "20px",
									marginTop: "30px",
									cursor: "pointer",
								}}
								type="submit"
							>
								Submit
							</button>
						</Form>
					)}
				</Formik>
			</div>
		</div>
	);
}

export default BusinessConfig;
